import { dataViewFormatter } from '@app/widgets/helpers/widgets';
import { EChartsOption, YAXisComponentOption } from 'echarts';

const BasicCartesianChartColourPalette = ['#6AB6B0', '#2A5FA5', '#52844B'];

const BasicCartesianChartEchartConfigTemplate: EChartsOption = {
  color: BasicCartesianChartColourPalette,
  legend: {},
  tooltip: {
    confine: true,
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985',
      },
    },
    textStyle: {
      color: '#fff',
    },
  },
  toolbox: {
    feature: {
      dataView: {
        show: true,
        readOnly: false,
        optionToContent: (option: any): string | HTMLElement => dataViewFormatter(option as EChartsOption),
      },
      saveAsImage: { show: true },
    },
  },
  grid: {
    top: '25%',
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: [],
  },
  yAxis: [],
  series: [],
};

const BasicCartesianChartAxisTemplate: YAXisComponentOption = {
  type: 'value',
  name: 'PLACEHOLDER',
  position: 'left',
  offset: 0,
  boundaryGap: [0, '100%'],
  alignTicks: true,
  axisLine: {
    show: true,
    lineStyle: {
      color: BasicCartesianChartColourPalette[0],
    },
  },
  axisLabel: {
    color: BasicCartesianChartColourPalette[0],
  },
};

export { BasicCartesianChartEchartConfigTemplate, BasicCartesianChartAxisTemplate, BasicCartesianChartColourPalette };
